import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import common from '@/utils/common'
import { getToken } from '@/utils/auth'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/protocol', '/forget']
const referrerList = ['DB', 'MD', 'TT', 'WJ', 'WW', 'YH']

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    /* has token */
    if (to.path.indexOf('/login') !== -1) {
      next({ path: '/' })
      NProgress.done()
    } else {
      // 未登录信息
      if (store.getters.elements === undefined) {
        // 获取用户信息（路由和view）
        store.dispatch('GetInfo').then(res => {
          console.warn(res)
          store.dispatch('GenerateRoutes', res.data).then(accessRoutes => {
            // 根据roles权限生成可访问的路由表
            accessRoutes.forEach(route => { router.addRoute(route) })
            // router.addRoutes(accessRoutes) // 动态添加可访问路由表
            // 储存patch用于判断
            next({ path: to.fullPath })
          })
        }).catch(err => {
          console.warn(err)
          store.dispatch('FedLogOut').then(() => {
            const referrer = sessionStorage.getItem('referrer')
            next({ path: '/login' + (referrer ? `/${referrer}` : '') })
          })
        })
      } else {
        // 直接访问
        // from.meta.keepAlive = true
        store.dispatch('resetPath', { to, from }).then(() => {
          next()
        })
      }
    }
  } else {
    /* has no token */
    // 推荐人转为大写字母判断
    const referrer = to.params.referrer ? to.params.referrer.toUpperCase() : ''
    if (whiteList.includes(to.path) || (to.path.indexOf('/login') !== -1 && referrerList.includes(referrer))) {
      // 在免登录白名单，直接进入
      next()
    } else {
      // 否则全部重定向到登录页面
      common.SET_REDIRECT_PATH(to.path)
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
